import { Dispatch } from "redux";
import {
  getModules,
  createModule,
  updateModule,
  deleteModule,
  getModuleByPojectId,
} from "../../services/ModuleService";
import { Module } from "../../types/Module";
import { getSubModuleByPojectId } from "../../services/SubModuleService";

export enum ModuleActionType {
  FETCH_MODULES = "FETCH_MODULES",
  ADD_MODULE = "ADD_MODULE",
  EDIT_MODULE = "EDIT_MODULE",
  DELETE_MODULE = "DELETE_MODULE",
  FETCH_MODULES_PROJECTID = "FETCH_MODULES_PROJECTID",
}

export interface FetchModules {
  type: ModuleActionType.FETCH_MODULES;
  data: Module[];
}

export interface AddModule {
  type: ModuleActionType.ADD_MODULE;
  data: Module;
}

export interface EditModule {
  type: ModuleActionType.EDIT_MODULE;
  data: Module;
}

export interface DeleteModule {
  type: ModuleActionType.DELETE_MODULE;
  data: number;
}

export interface FetchModulesProjecId {
  type: ModuleActionType.FETCH_MODULES_PROJECTID;
  data: Module[];
}

export type ModuleAction =
  | FetchModules
  | AddModule
  | EditModule
  | DeleteModule
  | FetchModulesProjecId;

export const fetchModules = () => async (dispatch: Dispatch) => {
  const data = await getModules();
  dispatch<FetchModules>({ type: ModuleActionType.FETCH_MODULES, data });
};

export const addModule = (mod: Module) => async (dispatch: Dispatch) => {
  const response = await createModule(mod);
  dispatch<AddModule>({
    type: ModuleActionType.ADD_MODULE,
    data: response.data.data,
  });
};

export const editModule =
  (id: number, mod: Module) => async (dispatch: Dispatch) => {
    const response = await updateModule(id, mod);
    dispatch<EditModule>({
      type: ModuleActionType.EDIT_MODULE,
      data: response.data.data,
    });
  };

export const deleteModuleById = (id: number) => async (dispatch: Dispatch) => {
  await deleteModule(id);
  dispatch<DeleteModule>({ type: ModuleActionType.DELETE_MODULE, data: id });
};

export const fetchModulesByProject =
  (projectId: number) => async (dispatch: Dispatch) => {
    try {
      const response = await getModuleByPojectId(projectId);

      dispatch<FetchModulesProjecId>({
        type: ModuleActionType.FETCH_MODULES_PROJECTID,
        data: response.data.data,
      });
    } catch (error) {
      console.error("Error fetching filtered modules", error);
    }
  };
